import { usePopup } from 'hooks/usePopup';

import { VerifyEmailType } from './verifyEmail.types';
import VerifyEmailPopup from './VerifyEmailPopup';

export const useVerifyEmailPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showVerifyEmailPopup = (
    email: string,
    password?: string,
    onConfirmed?: () => void,
    onClose?: () => void,
    verifyType?: VerifyEmailType
  ) =>
    showPopup(
      <VerifyEmailPopup
        credentials={{ email, password }}
        onConfirmed={() => {
          hidePopup();
          onConfirmed?.();
        }}
        verifyType={verifyType}
      />,
      {
        onClose: () => {
          hidePopup();
          onClose?.();
        },
      }
    );

  return { showVerifyEmailPopup };
};
